// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateQuestion_wrapper__CCAG9","logo":"CreateQuestion_logo__bqNVi","main_container":"CreateQuestion_main_container__D307s"};